// extracted by mini-css-extract-plugin
module.exports = {"leadStudios":"style_leadStudios__g_XUe","leadStudiosLogo":"style_leadStudiosLogo__apSyP"};